module.exports = __webpack_public_path__ + "static/img/img7.019e32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img7.png
// module id = UFcG
// module chunks = 36